import type { Validation } from '@/ui/types/Validation';

export function buildValidationResult(errors?: string[]): Validation | null {
  if (!Array.isArray(errors) || errors.length === 0) {
    return null;
  }

  return {
    type: 'invalid',
    messages: errors,
  };
}
